/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Success_MessageInputs */

const en_company_registration_success_message = /** @type {(inputs: Company_Registration_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for your interest in participating in the Matching Week. You will receive a response from us in the next few days.`)
};

const de_company_registration_success_message = /** @type {(inputs: Company_Registration_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danke für Ihr Interesse an einer Teilnahme an der Matching Week. Sie erhalten in den nächsten Tagen eine Rückmeldung von uns.`)
};

/**
* | output |
* | --- |
* | "Thank you for your interest in participating in the Matching Week. You will receive a response from us in the next few days." |
*
* @param {Company_Registration_Success_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_success_message = /** @type {((inputs?: Company_Registration_Success_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Success_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_success_message(inputs)
	return en_company_registration_success_message(inputs)
});